import React from "react";
import { Table, Button, Badge } from "reactstrap";
import FooterPagination from "../../Pagination/FooterPagination";
import { useNavigate, useParams } from "react-router-dom";
import ViewButton from "../../Buttons/ViewButton";
import UserStatusBadge from "../../Badges/UserStatusBadge";
import DropdownMenuActions from "../../Dropdown/DropdownMenuActions";
import { resentInvitation } from "../../../slices/general/thunk";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";

const NationalTable = ({ data, searchParam, searchDone, paginationProps }) => {
  const { id, role } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isNotSearchResult = searchParam && !data.length && searchDone;
  const noData = data.length === 0 && !searchParam;

  const handleViewProfile = (id) => {
    const route = `/national/${id}`;
    navigate(route);
  };

  const handleRowClick = (userId, event) => {
    const selection = window.getSelection().toString();
    if (!selection) {
      navigate(`/national/${userId}`);
    }
  };

  const handleResendInvitation = async (userId) => {
    try {
      const response = await dispatch(resentInvitation({ userId }));

      const res = response.payload;

      if (res && !res.error) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Invitation has been resent successfully",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invitation could not be resent",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Invitation could not be resent",
      });
      console.log(error);
    }
  };

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th scope="col">National Name</th>
          <th scope="col">Contact</th>
          <th scope="col">Number of GAs</th>
          <th scope="col" className="text-center">
            Status
          </th>
          <th scope="col" className="text-center">
            Manage
          </th>
        </tr>
      </thead>
      <tbody>
        {isNotSearchResult && (
          <tr>
            <td className="text-center" colSpan="12">
              No search results for "{searchParam}"
            </td>
          </tr>
        )}
        {noData ? (
          <tr>
            <td className="text-center" colSpan="6">
              {id && role
                ? `${textRoles[role]} has no Nationals yet.`
                : "There are no Nationals yet."}
            </td>
          </tr>
        ) : (
          data.map((national, index) => (
            <tr
              key={index}
              onClick={(event) => handleRowClick(national.id, event)}
              className="cursor-pointer"
            >
              <td
              // onClick={() => handleViewProfile(national.id)}
              // className="cursor-pointer text-primary text-hover-underlined fw-semibold"
              >
                {national.companyName}
              </td>
              <td>{national.email}</td>
              <td>{national.gaCount || "0"}</td>
              <td className="text-center fw-normal">
                <UserStatusBadge
                  status={national.firstLogin ? "Active" : "Invited"}
                  color={national.firstLogin ? "success" : "warning"}
                />
              </td>
              <td className="text-center">
                <DropdownMenuActions
                  onViewProfile={handleViewProfile}
                  onResendInvitation={handleResendInvitation}
                  item={national}
                  status={national.firstLogin ? "Active" : "Invited"}
                />
                {/* <ViewButton
                  user={national}
                  handleViewProfile={handleViewProfile}
                /> */}
              </td>
            </tr>
          ))
        )}
      </tbody>
      {paginationProps.totalItems > 0 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default NationalTable;
